"use client";
import classNames from "classnames";
import styles from "./index.mobile.module.scss";
import SelectProvider, {
  ExpandContext,
  ExpandProvider,
  OptionContext,
  OptionProvider,
  SearchContext,
  SearchProvider,
  SelectContext
} from "./providers.mobile";
import { ReactNode, useContext, useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import dynamic from "next/dynamic";
import { useSharedData } from "bossjob-remote/dist/hooks";
import searchIcon from "../../assets/searchIcon.svg";
import downArrow from "../../assets/downArrow.svg";
import newArrow from "../../assets/newArrow.svg";

import { Button } from "antd";
type MobileSelectProps<T> = {
  className?: string;
  options: T[];
  isMulty: boolean;
  getValue?: (item: T) => string | number;
  getLabel?: (item: T) => string | ReactNode;
  getChildren?: (item: T) => T[] | undefined;
  getParent?: (item: T) => T | null | undefined;
  placeholder: string;
  searchTitle: string;
  value: T | T[];
  onChange: (item: T) => void;
  onFocus?: () => void;
  prefixIcon?: React.ReactNode;
  suffixIcon?: React.ReactNode;
};

const MainContainer = (props) => {
  const { className, onFocus, prefixIcon, suffixIcon } = props;
  const { setActive, active } = useContext(SelectContext);
  const { inputPlaceholder, inputDisplayValue, selectedValue } = useContext(SearchContext);

  useEffect(() => {
    document.body.style.overflow = active ? "hidden" : "";
  }, [active]);

  return (
    <div
      className={classNames([styles.container, className])}
      onClick={(e) => {
        onFocus && onFocus();
        setActive(true);
      }}
    >
      {prefixIcon ? prefixIcon : null}

      <div className={styles.input}>
        {inputDisplayValue ? (
          <div className={classNames([styles.value, styles.selectLenWarp])}>
            <div
              className={classNames(styles.textOverflow, {
                [styles.textOverflowHasNumber]: selectedValue?.length > 1
              })}
            >
              {inputDisplayValue}
            </div>
            {selectedValue?.length > 1 ? (
              <span className={styles.selectLen}>
                {selectedValue?.length > 99 ? "99+" : selectedValue?.length}
              </span>
            ) : null}
          </div>
        ) : (
          <div
            className={classNames([
              styles.placeholder,
              "mobile-input-location-placeholder",
              styles.textOverflow
            ])}
          >
            {inputPlaceholder}
          </div>
        )}
      </div>

      {suffixIcon ? suffixIcon : <img src={newArrow} />}
    </div>
  );
};

// 扁平化 options 并生成完整路径的 label
const flattenOptionsWithPath = (options) => {
  const result = [];

  const flatten = (items, currentPath: string[], currentValue: (string | number)[]) => {
    items.forEach((item) => {
      const newPath = [...currentPath, item.label?.toString()];
      const newValue = [...currentValue, item.value];
      const labelPath = newPath.join(" / ");

      result.push({
        ...item,
        level: newPath.length
      });

      if (item.children) {
        flatten(item.children, newPath, newValue);
      }
    });
  };

  flatten(options, [], []);
  return result ?? [];
};

const highlightMatch = (text: string, searchValue: string) => {
  const regex = new RegExp(`(${searchValue})`, "gi");
  return text.replace(regex, (match) => `<span class=${styles.highlight}>${match}</span>`);
};

const PopContent = (props) => {
  const dictionary = useSharedData("DICTIONARY") || {};
  const { comm } = dictionary;

  const {
    active,
    setActive,
    options = [],
    onChange,
    selectedValue,
    onCallback
  } = useContext(SelectContext);
  const {
    searchMode,
    inputPlaceholder,
    inputDisplayValue,
    setSearchMode,
    setSearchValue,
    searchValue
  } = useContext(SearchContext);
  const { getChildren, getValue, getLabel } = useContext(SelectContext);
  // 动画完成以后需要从dom移除,节省性能
  const [display, show] = useDisplay(active);

  const searchResult = useMemo(() => {
    if (!searchMode || !searchValue) {
      return [];
    }
    const flatOption = flattenOptionsWithPath(options);
    const getResult = (options) => {
      return options.filter((item) =>
        getLabel(item)?.toLowerCase()?.includes(searchValue?.toLowerCase())
      );
    };
    const result = getResult(flatOption);
    const filterThenList = result.map((item) => {
      const titles = [getLabel(item)];
      let parent = item.parent;
      const getItemByValue = (options, value) => {
        const mapped = options.map((item) => {
          if (getValue(item) === value) {
            return item;
          } else {
            const children = getChildren(item);
            if (children?.length) {
              return getItemByValue(children, value);
            } else {
              return false;
            }
          }
        });
        return mapped.find((a) => a);
      };

      while (parent) {
        const parentItem = getItemByValue(options, parent);
        if (parentItem) {
          titles.unshift(getLabel(parentItem));
        }
        parent = parentItem?.parent;
      }

      return {
        label: (
          <span
            dangerouslySetInnerHTML={{ __html: highlightMatch(titles.join(" / "), searchValue) }}
          />
        ),
        value: getValue(item),
        data: item
      };
    });

    return (filterThenList ?? [])?.sort((a, b) => {
      return b.data?.level - a.data?.level;
    });
  }, [searchValue, searchMode, options]);

  return createPortal(
    <>
      {display && (
        <div
          // onClick={() => setActive(false)}
          className={classNames({
            [styles.popContent]: true,
            [styles.open]: show,
            [styles.close]: !show
          })}
        >
          <div className={styles.mask}></div>
          <div className={styles.mainContainer}>
            <div
              className={styles.topContainer}
              onClick={() => {
                // setActive(false);
              }}
            >
              <div className={styles.inputContent}>
                <img src={searchIcon}></img>
                <input
                  value={inputDisplayValue}
                  onFocus={() => {
                    // 如果需要焦点时,填充当前单选内容
                    // if (
                    //   selectedValue &&
                    //   (!Array.isArray(selectedValue) || selectedValue?.length == 1)
                    // ) {
                    //   setSearchValue(getLabel(selectedValue));
                    // }
                    setSearchMode(true);
                  }}
                  // onBlur={() => {
                  //   setSearchValue("");
                  //   setSearchMode(false);
                  // }}
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                  }}
                  placeholder={inputPlaceholder}
                ></input>
                <Button
                  type='link'
                  onClick={() => {
                    if (searchMode) {
                      setSearchValue("");
                      setSearchMode(false);
                    } else {
                      setSearchValue("");
                      setActive(false);
                      onCallback(selectedValue);
                    }
                  }}
                >
                  {searchMode ? comm.cancel || "Cancel" : comm.done || "Done"}
                </Button>
              </div>
            </div>
            <div className={styles.bottomContainer}>
              <OptionProvider getChildren={getChildren} getValue={getValue} getLabel={getLabel}>
                {searchMode && searchResult?.length ? (
                  <>
                    <div className={styles.searchContent}>
                      <SearchSelectList options={searchResult} />
                    </div>
                  </>
                ) : (
                  <ExpandProvider>
                    <div className={styles.itemListWrapper}>
                      <ItemList options={options} onChange={onChange} />
                    </div>
                  </ExpandProvider>
                )}
              </OptionProvider>
            </div>
          </div>
        </div>
      )}
    </>,
    document.body
  );
};
function SearchSelectList(props) {
  const { options } = props;
  const { setSelect } = useContext(OptionContext);
  const { setSearchMode } = useContext(SearchContext);
  return (
    <div className={styles.searchContent}>
      {options?.map?.((item) => {
        return (
          <SelectItem
            label={item.label}
            canExpand={false}
            expanded={false}
            isSelected={false}
            isHalfSelected={false}
            setSelect={() => {
              setSelect(item.data, false);
              setSearchMode(false);
            }}
            isMulty={false}
            level={0}
          />
        );
      })}
    </div>
  );
}
function SelectItem(props) {
  const [touched, setTouched] = useState(false);

  const {
    label,
    setExpand,
    expanded,
    isSelected,
    setSelect,
    isHalfSelected,
    level,
    isMulty,
    canExpand
  } = props;
  // "#F5F7FB"
  return (
    <div
      className={styles.selectItem}
      style={{
        paddingLeft: 20 + level * 16,
        background: touched ? "#F5F7FB" : "#fff"
      }}
      onContextMenu={(e) => {
        e.stopPropagation();
      }}
      onClick={(e) => {
        e.stopPropagation();
        if (canExpand) {
          setExpand();
        } else {
          setSelect();
        }
      }}
      onTouchStart={(e) => {
        // e.preventDefault();
        e.stopPropagation();
        setTouched(true);
      }}
      onTouchEnd={(e) => {
        // e.preventDefault();
        e.stopPropagation();
        setTouched(false);
      }}
    >
      {isMulty && (
        <span
          className={classNames({
            [styles.iconBox]: true,
            [styles.active]: isSelected,
            [styles.half]: isHalfSelected
          })}
          onClick={(e) => {
            e.stopPropagation();
            setSelect();
          }}
        />
      )}
      {label}
      {canExpand && (
        <img style={{ transform: expanded ? "rotateZ(180deg)" : undefined }} src={downArrow}></img>
      )}
    </div>
  );
}

function ItemList(props) {
  const { options = [], level = 0, expand } = props;
  const { getChildren, getLabel, getValue, isSelected, isHalfSelected, setSelect } =
    useContext(OptionContext);
  const { isExpanded, setExpandedItem } = useContext(ExpandContext);
  const [loadDoms, setLoadDoms] = useState(false);
  const [showDoms, setShowDoms] = useState(false);
  const [animating, setAnimating] = useState(false);
  const expandRef = useRef(false);
  const outContentRef = useRef(null);
  const subContentRef = useRef<any>(null);

  useEffect(() => {
    if (level == 0) {
      return;
    }
    if (animating) {
      return;
    }
    if (expandRef.current == expand) {
      return;
    }
    expandRef.current = expand;
    if (expand) {
      setLoadDoms(true);
      setAnimating(true);
      setTimeout(() => {
        setShowDoms(true);
      }, 20);
      setTimeout(() => {
        setAnimating(false);
      }, 320);
    } else {
      setTimeout(() => {
        setAnimating(false);
        setLoadDoms(false);
      }, 300);
      setShowDoms(false);
      setTimeout(() => {
        setAnimating(true);
      });
    }
  }, [level, expand, animating]);

  useEffect(() => {
    if (level == 0) {
      return;
    }
    if (outContentRef.current && subContentRef.current) {
      if (showDoms) {
        const height = subContentRef.current.clientHeight;
        outContentRef.current.style.height = height + "px";
        setTimeout(() => {
          if (outContentRef.current && outContentRef.current.style) {
            outContentRef.current.style.height = "auto";
          }
        }, 300);
      } else {
        outContentRef.current.style.height = outContentRef.current.clientHeight + "px";
        setTimeout(() => {
          if (outContentRef.current && outContentRef.current.style) {
            outContentRef.current.style.height = "0";
          }
        }, 20);
      }
    }
  }, [showDoms]);
  const { isMulty } = useContext(SelectContext);
  return (
    <>
      <div ref={outContentRef} className={styles.itemList}>
        <div ref={subContentRef} style={{ height: "fit-content" }}>
          {/* 子项没有展开的才不渲染,否则会影响3层以上的展开动画 */}
          {(loadDoms || level == 0 || options.filter(isExpanded).length > 0) &&
            options?.map((item) => {
              const label = getLabel(item);
              const expandChildren = isExpanded(item);
              const children = getChildren(item);
              return (
                <>
                  <div
                    style={{ display: "flex", flexDirection: "column", background: "#fff" }}
                    key={getValue(item)}
                  >
                    <SelectItem
                      label={label}
                      canExpand={children?.length > 0}
                      expanded={expandChildren}
                      isSelected={isSelected(item)}
                      isHalfSelected={isHalfSelected(item)}
                      setSelect={() => setSelect(item)}
                      isMulty={isMulty}
                      level={level}
                      setExpand={() => {
                        setExpandedItem(item);
                      }}
                    />
                  </div>
                  <div
                  // style={{ marginLeft: 20 }}
                  >
                    <OptionProvider level={level + 1}>
                      <ExpandProvider>
                        <ItemList
                          key={level + 1}
                          expand={expandChildren}
                          level={level + 1}
                          options={getChildren(item)}
                          parentItem={item}
                        />
                      </ExpandProvider>
                    </OptionProvider>
                  </div>
                </>
              );
            })}
        </div>
      </div>
    </>
  );
}

const PopContentNoSsr = dynamic(() => Promise.resolve(PopContent), { ssr: false });

function MobileSelect<T>(props: MobileSelectProps<T>) {
  const {
    options = [],
    getChildren,
    getValue,
    getLabel,
    getParent,
    className,
    isMulty,
    placeholder,
    searchTitle,
    value,
    onChange,
    onFocus = () => {},
    prefixIcon = null
  } = props;

  return (
    <SelectProvider
      options={options}
      getChildren={getChildren}
      getValue={getValue}
      getLabel={getLabel}
      getParent={getParent}
      isMulty={isMulty}
      initValue={value}
      onChange={onChange}
    >
      <SearchProvider inputPlaceholder={placeholder} inputTitle={searchTitle}>
        <MainContainer prefixIcon={prefixIcon} className={className} onFocus={onFocus} />

        <PopContentNoSsr getChildren={getChildren} getValue={getValue} getLabel={getLabel} />
      </SearchProvider>
    </SelectProvider>
  );
}
export default MobileSelect;

function useDisplay(active) {
  const [display, setDisplay] = useState(false);
  const [show, setShow] = useState(false);
  const [animating, setAnimating] = useState(false);
  const activeRef = useRef(false);
  useEffect(() => {
    // 动画期间不允许打断
    if (animating) {
      return;
    }
    // 只有active变化才执行逻辑, 如果animating变化也执行会死循环
    if (activeRef.current == active) {
      return;
    }
    activeRef.current = active;
    if (active) {
      setDisplay(true);
      setAnimating(true);
      setTimeout(() => {
        setShow(true);
      }, 20);
      setTimeout(() => {
        setAnimating(false);
      }, 220);
    } else {
      setShow(false);
      setAnimating(true);
      setTimeout(() => {
        setDisplay(false);
        setAnimating(false);
      }, 200);
    }
  }, [active, animating]);
  return [display, show];
}
